import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import LogoIcon from '../../../assets/images/Learnit_logo.svg';
import { AuthLayout } from '../../../components/common/AuthLayout';
import { LogoButton } from '../../../components/common/buttons/LogoButton';
import { LoginForm } from '../../../components/forms/LoginForm';
import InvalidEmail from '../../../components/common/AuthLayout/EmailSent';
import CreatePasswordBanner from '../../../components/common/AuthLayout/CreatePasswordBanner';
import CompanyBanner from '../../../components/common/AuthLayout/CompanyBanner';
import LoadingOverlay from '../../../components/common/LoadingOverlay';
import { useErrorRequestParam } from '../../../hooks/hooks';
import { getInviteDetails } from '../../../requests';
import { ICompany } from '../../../models/ICompany';

export const Login = () => {
  const location = useLocation();
  const checkInviteDetails = location.state?.checkInviteDetails || false;

  const [emailSent, setEmailSent] = useState(false);
  const [loading, setLoading] = useState(checkInviteDetails);
  const [company, setCompany] = useState<ICompany | null>(null);

  useErrorRequestParam();

  useEffect(() => {
    if (checkInviteDetails) {
      getInviteDetails()
        .then((response) => {
          setCompany(response.company);
        })
        .finally(() => setLoading(false));
    }
  }, [checkInviteDetails]);

  return (
    <AuthLayout
      button={<LogoButton logo={LogoIcon} />}
      banner={
        company && company.enforceSaml ? (
          <CompanyBanner company={company} />
        ) : (
          !loading && <CreatePasswordBanner />
        )
      }
    >
      {loading ? (
        <LoadingOverlay text="Loading..." />
      ) : emailSent ? (
        <InvalidEmail title="Activation link sent" />
      ) : (
        <LoginForm setEmailSent={setEmailSent} />
      )}
    </AuthLayout>
  );
};
